// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list__fallback[data-v-5c1d9aef]{text-align:center}.title-list__redirect[data-v-5c1d9aef]{display:flex;justify-content:center;margin-bottom:var(--jw-spacing-16)}", ""]);
// Exports
module.exports = exports;
